export enum Auth0ErrorCode {
  ACCOUNT_SELECTION_REQUIRED = 'account_selection_required',
  CONSENT_REQUIRED = 'consent_required',
  INTERACTION_REQUIRED = 'interaction_required',
  INVALID_REQUEST_OBJECT = 'invalid_request_object',
  INVALID_REQUEST_URI = 'invalid_request_uri',
  INVALID_TOKEN = 'invalid_token',
  LOGIN_REQUIRED = 'login_required',
  REGISTRATION_NOT_SUPPORTED = 'registration_not_supported',
  REQUEST_ERROR = 'request_error',
  REQUEST_NOT_SUPPORTED = 'request_not_supported',
  REQUEST_URI_NOT_SUPPORTED = 'request_uri_not_supported',
  TIMEOUT = 'timeout',
}
